import React, {useMemo} from 'react';

import {FlowchartConfigWithMetadata} from '../../redux/flowchartConfigAutosaveManagerCallbacks';
import {buildTransitionIndexByPTDVPair} from './transitionKeyUtils';
import {TransitionsContextProvider, TransitionsContextValue} from './TransitionsContext';

export interface TransitionsManagerProps {
  draftFlowchartConfigAndMetadata: FlowchartConfigWithMetadata;
  children: React.ReactNode;
}

/**
 * Convenience provider for accessing transitions.
 * @param props.draftFlowchartConfigAndMetadata - The current draft flowchart config and metadata
 * @param props.children - The children to render
 */
export default function TransitionsManager(props: TransitionsManagerProps): JSX.Element {
  const transitionsContextValue: TransitionsContextValue = useMemo(
    () => ({
      transitionsById: props.draftFlowchartConfigAndMetadata.metadata.transitions,
      ptdvPairToTransitionIdIndex: buildTransitionIndexByPTDVPair(
        props.draftFlowchartConfigAndMetadata.metadata.transitions
      ),
    }),
    [props.draftFlowchartConfigAndMetadata.metadata.transitions]
  );

  return (
    <TransitionsContextProvider value={transitionsContextValue}>{props.children}</TransitionsContextProvider>
  );
}
